<template scoped>
  <div v-show="loading" class="spinner-wrapper">
    <div class="spinner-card">
      <img class="p-0 spinner-img" src="../assets/Empanel-loading.gif" />
      <!--h5 class="mt-4 ml-n3">{{ $t('Loading...') }}</h5-->
      <!-- <p>{{ $t('COMMON.PLEASE_WAIT_WE_ARE_COOKING_SOMETHING_FOR_YOU') }}</p> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["loadSpinner"],
  data() {
    return {
      apiOngoingCount: 0,
      loading: false
    }
  },
  methods: {
    loader(isLoading) {
      // console.log('this.apiOngoingCount' + this.apiOngoingCount)
      if (isLoading) {
        this.apiOngoingCount++;
        this.loading = true;
      } else if (this.apiOngoingCount > 0) {
        this.apiOngoingCount--;
        this.loading = (this.apiOngoingCount > 0);
      }
    }
  },
  created() {
    var self = this
    EventBus.$on('showspinner',function(){
      self.loader(true)
    });
    EventBus.$on('hidespinner',function(){
      self.loader(false)
    });
  }
};
</script>

<style scoped>
html,
body {
  height: 100%;
  width: 100%;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
}
.spinner-wrapper {
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  /* width: calc(100vw - 240px); */
  width: 100%;
  /* background: rgb(16%, 16%, 16%); */
  /* background: rgba(42, 42, 42, 0.7); */
  /* background: rgba(0, 0, 0, 0.85); */
  /* background: #1313136c; */
  z-index: 1000;
}
.spinner-card {
  position: absolute; 
  left: 48%;
  top: 44%;
  padding: 10px 9px 8px 10px;
  background: #ffffff;
  border-radius: 70px;
  box-shadow: 0 0 5px #00000050;
}
.spinner-card h5 {
  position: absolute;
  top: 130px;
  left: 163px;
  color: #190f27;
}
.spinner-card p {
  position: absolute;
  top: 165px;
  left: 35px;
  color: #473f52;
}
.spinner {
  -webkit-animation: rotator 1.4s linear infinite;
  animation: rotator 1.4s linear infinite;
  position: absolute;
  left: 158px;
  top: 35px;
  z-index: 1001;
}
.spinner-img {
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
  width: 64px;
    height: 65px;
    filter: contrast(0.8);
}
</style>
